import { AttachmentUploadData } from "./forms/attachments/attachment-upload";
import { AttachmentWithUrl, ResolvedAttachments } from "./forms/attachments/resolved-attachments";
export interface BasicAttachmentData {
    name: string;
    size: number;
    type: string;
    url: string;
  }

export class ModalAttachments {
    public readonly name: string;
    public readonly size: number;
    public readonly type: string;
    public readonly url: string;
  
    constructor(init: AttachmentUploadData | AttachmentWithUrl | BasicAttachmentData) {
      // Handle AttachmentUploadData
      if ('uploadDate' in init) {
        this.name = init.name;
        this.size = init.size;
        this.type = init.type;
        this.url = init.url;
      }
   // Handle AttachmentWithUrl
   else if ('blobName' in init) {
    this.name = init.fileName || this.extractNameFromBlobName(init.blobName);
    this.size = init.fileSize; // Size not available in AttachmentWithUrl
    this.type = init.contentType;
    this.url = init.url;
  }
  // Handle BasicAttachmentData (plain object)
  else {
    this.name = init.name;
    this.size = init.size;
    this.type = init.type;
    this.url = init.url;
  }
    }
  
    private extractNameFromBlobName(blobName: string): string {
      const parts = blobName.split('/');
      const filename = parts[parts.length - 1];
      return filename || blobName;
    }
  
    
  
    // Static method to transform arrays
    static fromAttachmentList(attachments: (AttachmentUploadData | AttachmentWithUrl)[]): ModalAttachments[] {
      return attachments.map(attachment => new ModalAttachments(attachment));
    }
  }
  